import type { Processor } from '@app/store/middleware/processorMiddleware.js';
import { mapsLoaded } from '@features/myMaps/model/actions.js';
import {
  routePlannerAddPoint,
  routePlannerRecompute,
  routePlannerRemovePoint,
  routePlannerSetFinish,
  routePlannerSetIsochroneParams,
  routePlannerSetMode,
  routePlannerSetParams,
  routePlannerSetPoint,
  routePlannerSetPoints,
  routePlannerSetRoundtripParams,
  routePlannerSetStart,
  routePlannerSetTransportType,
  routePlannerSwapEnds,
} from '../actions.js';
import { mapDataHasRoute } from '../reducer.js';

export const updateRouteTypes = [
  routePlannerSetStart,
  routePlannerSetFinish,
  routePlannerSwapEnds,
  routePlannerAddPoint,
  routePlannerSetPoint,
  routePlannerSetPoints,
  routePlannerRemovePoint,
  routePlannerSetTransportType,
  routePlannerSetMode,
  routePlannerSetParams,
  routePlannerSetRoundtripParams,
  routePlannerSetIsochroneParams,
  routePlannerRecompute,
  mapsLoaded,
];

export const routePlannerFindRouteProcessor: Processor = {
  actionCreator: updateRouteTypes,
  // A map that stored its route is already showing it — asking the router again
  // would cost a request, fail offline, and answer with whatever the routing
  // graph says today rather than what was planned.
  actionPredicate: (action) =>
    !mapsLoaded.match(action) ||
    !mapDataHasRoute(action.payload.data.routePlanner),
  id: 'routePlanner',
  // route-fetch errors are reported by the handler itself (see
  // findRouteProcessorHandler); unexpected throws fall back to the generic
  // processor-error toast.
  handle: async (...params) =>
    (
      await import(
        /* webpackChunkName: "route-planner-find-route-processor-handler" */
        './findRouteProcessorHandler.js'
      )
    ).default(...params),
};
